export const ACTION_TYPE = {
  create: "create",
  update: "update",
  read: "read",
  delete: "delete",
};

export const MODULE = {
  properties: "properties",
};

export const MODULE_NAMES = {
  propertyCreate: "property-create",
  propertyUpdate: "property-update",
  propertyDelete: "property-delete",
  propertyPublish: "property-publish",
  propertyUnpublish: "property-unpublish",
};
